import {
    faBagsShopping,
    faBenchTree,
    faLandmark,
    faFort,
    faPalette,
    faCourtSport,
    faBed,
    faPlateUtensils,
    faMartiniGlass,
    faHospital,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createColumnHelper } from '@tanstack/react-table';
import { useIntl } from 'react-intl';

import { CellPointOfInterestActions } from 'src/features/parkingManagement/components/PointsOfInterest/CellPointOfInterestAction';
import { type ParkingPointsOfInterest, POINTS_OF_INTEREST } from 'src/features/parkingManagement/types/parking';
import { parkingManagementMessages } from 'src/features/parkingManagement/utils/messages';
import { DataTableColumnGenericHeaderDefinition, DataTableColumnHeader } from 'src/registry/components/table';
import { generalMessages } from 'src/utils/messages';

const columnHelper = createColumnHelper<ParkingPointsOfInterest>();

export const iconsPointsOfInterest = {
    [POINTS_OF_INTEREST.SHOPPING_CENTER]: faBagsShopping,
    [POINTS_OF_INTEREST.PARK]: faBenchTree,
    [POINTS_OF_INTEREST.MUSEUM]: faLandmark,
    [POINTS_OF_INTEREST.HISTORICAL_SITE]: faFort,
    [POINTS_OF_INTEREST.GALLERY]: faPalette,
    [POINTS_OF_INTEREST.STADIUM]: faCourtSport,
    [POINTS_OF_INTEREST.HOTEL]: faBed,
    [POINTS_OF_INTEREST.RESTAURANT]: faPlateUtensils,
    [POINTS_OF_INTEREST.BAR]: faMartiniGlass,
    [POINTS_OF_INTEREST.HOSPITAL]: faHospital,
};

const translationsPointsOfInterest = {
    [POINTS_OF_INTEREST.SHOPPING_CENTER]: parkingManagementMessages.shoppingCenter,
    [POINTS_OF_INTEREST.PARK]: parkingManagementMessages.park,
    [POINTS_OF_INTEREST.MUSEUM]: parkingManagementMessages.museum,
    [POINTS_OF_INTEREST.HISTORICAL_SITE]: parkingManagementMessages.historicalSite,
    [POINTS_OF_INTEREST.GALLERY]: parkingManagementMessages.gallery,
    [POINTS_OF_INTEREST.STADIUM]: parkingManagementMessages.stadium,
    [POINTS_OF_INTEREST.HOTEL]: parkingManagementMessages.hotel,
    [POINTS_OF_INTEREST.RESTAURANT]: parkingManagementMessages.restaurant,
    [POINTS_OF_INTEREST.BAR]: parkingManagementMessages.bar,
    [POINTS_OF_INTEREST.HOSPITAL]: parkingManagementMessages.hospital,
};

export const PointsOfInterestTableColumns = ({
    openDeleteModal,
}: {
    openDeleteModal: (point: ParkingPointsOfInterest) => void;
}) => {
    const { formatMessage } = useIntl();

    return [
        columnHelper.accessor('name', {
            header: DataTableColumnHeader,
            meta: {
                title: formatMessage(generalMessages.name),
            },
        }),
        columnHelper.accessor('type', {
            header: DataTableColumnHeader,
            cell: ({ row }) => {
                return (
                    <div className="flex items-center justify-center gap-2">
                        <FontAwesomeIcon icon={iconsPointsOfInterest[row.original.type]} className="text-primary-600" />
                        {formatMessage(translationsPointsOfInterest[row.original.type])}
                    </div>
                );
            },
            meta: {
                title: formatMessage(parkingManagementMessages.type),
            },
        }),
        columnHelper.display({
            header: DataTableColumnGenericHeaderDefinition,
            id: 'actions',
            cell: (props) => <CellPointOfInterestActions deleteCallback={openDeleteModal} {...props} />,
        }),
    ];
};
